import { axiosInstance } from './axiosConfig';

// Use the configured axios instance
export const api = axiosInstance;

// Auth API endpoints
export const authAPI = {
  register: async (email: string, password: string, username?: string) => {
    const response = await api.post('/auth/register', { email, password, username });
    return response.data;
  },
  
  login: async (email: string, password: string) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },
  
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  
  updateUser: async (data: { username?: string; metadata?: any }) => {
    const response = await api.put('/users/me', data);
    return response.data;
  },
  
  deleteUser: async () => {
    const response = await api.delete('/users/me');
    return response.data;
  },
};

// Conversation API endpoints
export const conversationAPI = {
  create: async (title?: string) => {
    const response = await api.post('/conversations', { title });
    return response.data;
  },
  
  list: async (limit: number = 20, offset: number = 0) => {
    const response = await api.get('/conversations', { params: { limit, offset } });
    return response.data;
  },
  
  get: async (conversationId: string) => {
    const response = await api.get(`/conversations/${conversationId}`);
    return response.data;
  },
  
  update: async (conversationId: string, data: { title?: string; metadata?: any }) => {
    const response = await api.put(`/conversations/${conversationId}`, data);
    return response.data;
  },
  
  delete: async (conversationId: string) => {
    const response = await api.delete(`/conversations/${conversationId}`);
    return response.data;
  },
};

// Chat API endpoints
export const chatAPI = {
  sendMessage: async (conversationId: string, message: string) => {
    const response = await api.post('/chat', { 
      message,
      conversation_id: conversationId,
      new_conversation: false
    });
    return response.data;
  },
  
  getMessages: async (conversationId: string, limit: number = 50, offset: number = 0) => {
    // Get conversation history which includes messages
    const response = await api.get(`/conversations/${conversationId}`);
    // Return the full response which includes both conversation and messages
    return response.data;
  },
};

// File API endpoints
export const fileAPI = {
  upload: async (file: File, conversationId?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    
    // Build URL with conversation_id if provided
    const uploadUrl = conversationId ? `/upload?conversation_id=${conversationId}` : '/upload';
    
    const response = await api.post(uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  
  download: async (fileId: string) => {
    const response = await api.get(`/files/${fileId}`, {
      responseType: 'blob',
    });
    return response.data;
  },
  
  getInfo: async (fileId: string) => {
    const response = await api.get(`/files/${fileId}/info`);
    return response.data;
  },
  
  list: async (conversationId: string) => {
    const response = await api.get(`/conversations/${conversationId}/files`);
    return response.data;
  },
};
